var findIndex = require('./findIndex');

    /**
     * Returns first item that matches criteria
     */
    function find(arr, iterator, thisObj){
        var idx = findIndex(arr, iterator, thisObj);
        return idx >= 0? arr[idx] : void(0);
    }

    module.exports = find;





//////////////////
// WEBPACK FOOTER
// ./~/mout/array/find.js
// module id = 380
// module chunks = 0 1 2